import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// CLIENT-TAKEOVER CONTRACT (Bloque 2B, Opción B): the prerender injects, into each pilot snapshot's
// <head>, a marker <script>window.__RITUAL_PRERENDERED_PATH__="<route>";</script> that runs before
// this bundle. For those snapshots we DO NOT hydrate — hydrateRoot required a byte-perfect first
// render which is impossible here (the snapshot is a settled, post-effect DOM produced by a client
// createRoot serialization + Framer Motion inline styles). Instead React takes over with createRoot:
//   1. the crawler/first paint already shows the full snapshot HTML (SEO + LCP intact);
//   2. createRoot renders the identical tree and replaces #root content in a single commit;
//   3. __RITUAL_HYDRATING__ suppresses Framer Motion ENTRANCE on this first client paint so the
//      swap is visually seamless (no flicker); its own effect flips it back to false after mount so
//      all subsequent animations/interactions work normally.
// createRoot is also used for normal SPA loads and dev (empty #root).
const takeoverPath =
  typeof window !== "undefined" ? window.__RITUAL_PRERENDERED_PATH__ : null;
const isTakeover =
  Boolean(takeoverPath) &&
  takeoverPath === window.location.pathname &&
  Boolean(container.firstElementChild);

if (isTakeover) {
  // Suppress Framer Motion entrance on the first client paint => the createRoot swap is seamless.
  window.__RITUAL_HYDRATING__ = true;
  window.__RITUAL_RECOVERABLE_ERRORS__ = [];
  // Drop the snapshot's dynamically-injected JSON-LD so the page effect re-creates exactly one.
  const staleJsonLd = document.getElementById("local-detalle-jsonld");
  if (staleJsonLd) staleJsonLd.remove();
  ReactDOM.createRoot(container).render(tree); // client takeover — NOT hydrateRoot
  window.__RITUAL_DID_TAKEOVER__ = true; // evidence for the prerender takeover gate
} else {
  ReactDOM.createRoot(container).render(tree);
}
